// Web mock for react-native-document-picker
export const types = {
  allFiles: '*/*',
  images: 'image/*',
  plainText: 'text/plain',
  audio: 'audio/*',
  pdf: 'application/pdf',
  zip: 'application/zip',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
};

export async function pick(options = {}) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = options.allowMultiSelection || false;
    input.accept = options.type || types.allFiles;

    input.onchange = (event) => {
      const files = Array.from(event.target.files);
      if (files.length === 0) {
        reject(new Error('User canceled document picker'));
        return;
      }

      const results = files.map(file => ({
        uri: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
        type: file.type,
        fileCopyUri: null,
      }));

      resolve(options.allowMultiSelection ? results : results[0]);
    };

    input.oncancel = () => {
      reject(new Error('User canceled document picker'));
    };

    input.click();
  });
}

export async function pickSingle(options = {}) {
  const result = await pick({ ...options, allowMultiSelection: false });
  return result;
}

export async function pickMultiple(options = {}) {
  const result = await pick({ ...options, allowMultiSelection: true });
  return result;
}

export function isInProgress() {
  return false;
}

export default {
  types,
  pick,
  pickSingle,
  pickMultiple,
  isInProgress,
};
